import HelpCustomersPage from '@/pages/help/customers';

export default HelpCustomersPage;
